import {defineMessages} from 'react-intl';

export default defineMessages({
	label: {
		id: 'orders.details.payment.label',
		defaultMessage: 'Payment'
	},
});
